(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/lobby.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/lobby.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useEffect,
  useContext,
  useState,
  useRef,
  useMemo
} = React;
const Lobby = () => {
  const {
    InfoOverlay,
    Background,
    TicketsRowWrapper
  } = svs.eInstant.shared.components;
  const {
    state: {
      gameUrl,
      categories: initialCategories = []
    }
  } = useContext(svs.eInstant.store.RouterContext);
  const {
    LOBBY
  } = svs.eInstant.constants.ROUTES;
  const WidgetArea = svs.eInstant.lobby.WidgetArea;
  const {
    update
  } = svs.eInstant.shared.hooks.useMetaTags();
  const validateGameConfig = svs.eInstant.util.validateGameConfig;
  const Loader = svs.eInstant.components.Loader;
  const wrapperRef = useRef(null);
  const {
    scrollToPosition
  } = svs.eInstant.shared.hooks.useScrollPosition({
    element: wrapperRef
  });
  const [isContentVisible, setIsContentVisible] = useState(false);
  const [heroWidgetLoaded, setHeroWidgetLoaded] = useState(false);
  const [lobbyWidgetLoaded, setLobbyWidgetLoaded] = useState(false);
  const categories = useMemo(() => (initialCategories || []).map(category => _objectSpread(_objectSpread({}, category), {}, {
    games: category.games.filter(g => validateGameConfig(g)).slice(0, 8)
  })).filter(_ref => {
    let {
      games = []
    } = _ref;
    return (games === null || games === void 0 ? void 0 : games.length) > 0;
  }).map(category => React.createElement("div", {
    className: "margin-v-3",
    key: category.urlPath
  }, React.createElement(TicketsRowWrapper, {
    category: category
  }))), [initialCategories]);
  useEffect(() => {
    !gameUrl && update(LOBBY);
  }, [gameUrl]);
  useEffect(() => {
    if (heroWidgetLoaded && lobbyWidgetLoaded) {
      setIsContentVisible(true);
      scrollToPosition();
    }
  }, [heroWidgetLoaded, lobbyWidgetLoaded]);
  return React.createElement(React.Fragment, null, !isContentVisible && React.createElement(Loader, null), React.createElement(InfoOverlay, null), React.createElement("div", {
    className: "js-e-instant lobby-page relative ".concat(isContentVisible ? 'content-visible' : 'content-hidden', " tickets-einstant-ribbon-theme"),
    ref: wrapperRef
  }, React.createElement(WidgetArea, {
    areaName: "hero",
    className: "full-width-widget overlapped overlap-padding",
    onLoaded: setHeroWidgetLoaded
  }), React.createElement(Background, {
    classNames: "tickets-einstant-lobby-container"
  }, React.createElement("div", {
    className: "lobby-category-container tickets-einstant-max-width"
  }, categories), React.createElement(WidgetArea, {
    areaName: "lobby",
    className: "u-text-left widget-default-margin-top-0 widget-area-e-instant-lobby",
    onLoaded: setLobbyWidgetLoaded
  }))));
};
setGlobal('svs.eInstant.lobby.Lobby', Lobby);

 })(window);